import CripNotice from 'crip-vue-notice';
import { notify } from '@/common/utils/notify';

export const isAuthenticated = (to, from, next) => {
  if (localStorage.getItem('auth-token') === null) {
    notify('word.login', 'sentence.login_or_register_continue');
    next({ name: 'login', query: { next: to.fullPath } });
    return;
  }
  next();
};

export const isNotAuthenticated = (to, from, next) => {
  if (localStorage.getItem('auth-token') !== null) {
    // eslint-disable-next-line no-new
    new CripNotice({
      title: 'Al ingelogd',
      description: 'Wij hebben u naar de home-pagina geleid omdat u een'
        + ' pagina probeerde te bezoeken waar u alleen heen kunt als u niet bent ingelogd.',
      className: 'open-normal',
      duration: 10,
    });

    next({ name: 'dashboard' });
    return;
  }
  next();
};
